import React from "react";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    container: {
        height: 40,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center'
    }
}));
const ActionsBar = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Button size={"small"} variant={"contained"} color={"primary"}>
                Save
            </Button>
            <Button size={"small"} variant={"outlined"} color={"secondary"} style={{marginLeft: 5}}>
                Delete
            </Button>
            <Button size={"small"} variant={"contained"} color={"default"} style={{marginLeft: 5}}>
                Cancel
            </Button>
        </div>
    )
};
ActionsBar.propTypes = {};
export default ActionsBar